import { LOGO_URL } from "@/data";
import { CallButton, DirectionsButton } from "./Buttons";
import * as Icons from "lucide-react";

export default function FreeDiagnostic() {
  return (
    <section id="diagnostic" data-testid="diagnostic-section" className="relative py-20 md:py-28 px-4 md:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="relative rounded-3xl md:rounded-[2rem] overflow-hidden bg-brand-navy text-white p-8 md:p-16 shadow-2xl">
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-brand-red/40 blur-[100px]" aria-hidden />
          <div className="absolute -bottom-32 -left-20 w-80 h-80 rounded-full bg-brand-blue/30 blur-[120px]" aria-hidden />
          <div className="absolute inset-0 grid-bg-light opacity-[0.06]" aria-hidden />

          <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">
            <div className="lg:col-span-2">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-red/15 border border-brand-red/30 mb-5">
                <Icons.Stethoscope className="w-3.5 h-3.5 text-brand-red" />
                <span className="text-xs font-bold uppercase tracking-widest text-white">$0 Diagnostic</span>
              </div>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight leading-[1.05]">
                Phone acting up?<br />
                <span className="text-brand-red">Plug-Man's got you.</span>
              </h2>
              <p className="mt-5 text-base md:text-lg text-white/85 max-w-2xl">
                Bring it in and our experienced technicians will diagnose the issue
                <strong className="text-white"> for free</strong>. We'll explain what's wrong, what it costs, and your best options before doing anything.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <CallButton testid="diagnostic-call-btn">Get Free Diagnostic</CallButton>
                <DirectionsButton testid="diagnostic-directions-btn" variant="secondary" />
              </div>

              <div className="mt-8 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-white/60">
                <span className="w-6 h-px bg-white/40" />
                Meet Plug-Man · your local tech hero since 2011
              </div>
            </div>

            {/* PLUG-MAN MASCOT */}
            <div className="relative grid place-items-center">
              <div className="relative">
                {/* Glow ring */}
                <div className="absolute inset-0 rounded-full bg-brand-red/40 blur-3xl scale-90 animate-pulse" aria-hidden />
                <div className="absolute inset-0 rounded-full bg-brand-blue/20 blur-2xl scale-75" aria-hidden />

                {/* Mascot card */}
                <div
                  data-testid="plugman-mascot"
                  className="relative w-56 h-56 md:w-64 md:h-64 rounded-3xl overflow-hidden bg-black ring-4 ring-white/10 shadow-2xl animate-float"
                >
                  <img
                    src={LOGO_URL}
                    alt="Plug-Man — Your Phone Plug mascot"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>

                {/* Floating speech bubble */}
                <div className="absolute -top-3 -left-8 bg-white text-brand-navy rounded-2xl px-4 py-2.5 shadow-xl rotate-[-4deg] hidden md:block">
                  <div className="text-[10px] uppercase font-bold tracking-widest text-brand-red mb-0.5">PLUG-MAN SAYS</div>
                  <div className="font-display font-extrabold text-sm">"Bring it in. I got you."</div>
                  <span className="absolute -bottom-2 left-6 w-3 h-3 bg-white rotate-45" />
                </div>

                {/* $0 badge */}
                <div className="absolute -bottom-4 -right-4 bg-brand-red text-white rounded-2xl px-4 py-3 shadow-xl glow-red rotate-[6deg]">
                  <div className="font-display font-black text-2xl leading-none">$0</div>
                  <div className="text-[9px] uppercase font-bold tracking-wider mt-0.5">DIAGNOSTIC</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
